import React, {useEffect, useState} from 'react';
import { url } from '../../../../Config';
import axios from 'axios';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Swal from "sweetalert2";


export default function Nl_reopen(props) {
      const [data, setdata] = useState([]);
      const [bool, setbool] = useState(false);
      const [status, setstatus] = useState('loading');
      const [searchTerm, setSearchTerm] = useState("");
      // const [reason, setreason] = useState(Array(data.length));
      const [open, setOpen] = useState(false);
      const [message, setmessage] = useState();
      const [open2, setOpen2] = useState(false);
      const [message2, setmessage2] = useState();
      const [alertType, setAlertType] = useState("error");
      const id = localStorage.getItem("userID");
      var a = 1;
  
  
  
      function DateFormat(params) {
          if (params == null) {
            return "-";
          } else {
            const date = new Date(params);
            const yyyy = date.getFullYear();
            const yy = yyyy.toString();
            const y = yy.slice(2, 4);
            let mm = date.toLocaleString("default", { month: "short" });
            let dd = date.getDate();
            if (dd < 10) dd = "0" + dd;
            return dd + "-" + mm + "-" + y;
          }
        }
  
      useEffect(()=>{
  
          const func = async ()=>{
              const res = await axios.get(`${url}/api/myinprocess3/19`);
              const resp = res.data;
              let arr = [];

               const data2 = resp;
               const arr2 = [];
               for(let i in data2){
                    if(data2[i].user_id == id || data2[i].lead_rc_id == id || data2[i].user_id1 == id || id == "441"){
                        arr2.push(data2[i]);
                    }
                }
              
              if(Number(id) == 19){
                for(let i in resp){
                    if(resp[i].nl_status == 'Entered'){
                        arr.push(resp[i]);
                    }
                }
                setdata(arr);
                setstatus('loaded');
              }

              else{
                // Define custom order
                const statusPriority = {
                    'Entered': 0,
                    'Open': 1,
                    'Closed': 2,
                    'Declined':3,
                    null: 4,       // null at the bottom
                    undefined: 4,  // handle undefined too
                };

                arr2.sort(function (a, b) {
                    var priorityA = (a.nl_status in statusPriority) ? statusPriority[a.nl_status] : 3;
                    var priorityB = (b.nl_status in statusPriority) ? statusPriority[b.nl_status] : 3;
                    return priorityA - priorityB;
                    });

                setdata(arr2);
                setstatus('loaded');

              }

        }

          func();
      },[bool])
  
      // const [open, setOpen] = useState(Array(props.myinprocess.length).fill(false));
      let filteredOpinions = [];
      filteredOpinions = data.filter((value) => {
  
      if(searchTerm !== null){
        let Entity = [];
        if(value['Entity'] !== null){
          Entity = value['Entity'].toLowerCase().includes(searchTerm.toLowerCase());
        }
    
        return Entity;
      }

      else if(searchTerm == null){
        return data;
      }
      }
      );
  
      const request = async(event, record_id, reason, sub, load, btn)=>{
          event.preventDefault();
          sub.hidden = true;
          load.hidden = false;
          btn.disabled = true;
  
          const res = await axios.post(`${url}/api/request_nl`,{
              'record_id' : record_id,
              'reason': reason
          });

          console.log(res, "Res");
          
          const resp = res.data;
          if(resp.status == true){
              sub.hidden = false;
              load.hidden = true;
              window.location.reload();
          }
          else{
              btn.disabled = false;
              sub.hidden = false;
              load.hidden = true;
              setOpen(true);
              setmessage(resp.messages); 
          }
      }

      const recommend = async(event, record_id, comment, sub, load, btn)=>{
          event.preventDefault();
          sub.hidden = true;
          load.hidden = false;
          btn.disabled = true;
  
          const res = await axios.post(`${url}/api/recommend_nl`,{
              'record_id' : record_id,
              'reason': comment
          });
          
          const resp = res.data;
          if(resp.status == true){
              sub.hidden = false;
              load.hidden = true;
              window.location.reload();
          }
          else{
              btn.disabled = false;
              sub.hidden = false;
              load.hidden = true;
              setOpen(true);
              setmessage(resp.messages); 
          }
      }

      const decline = async(record_id)=>{
          Swal.fire({ title: 'Are you sure you want to Decline this request?', 
            showDenyButton: false, showCancelButton: true, confirmButtonText: 'Decline'})
            .then(async(result) => {
              if (result.isConfirmed) {
                setOpen2(false);
                const res = await axios.post(`${url}/api/decline_nl`,{
              'record_id' : record_id,
                });
                
                const resp = res.data;
                if(resp.status == true){
                    setstatus('loading');
                    setbool(!bool)
                    setmessage2(resp.message);
                    setOpen2(true);
                    setAlertType('success');
                }
                else{
                    setmessage2(resp.message);
                    setOpen2(true);
                    setAlertType('error');
                }

          }
        })
    }

      const approve = async(record_id)=>{
        
        Swal.fire({ title: 'Are you sure you want to Approve this request?', 
            showDenyButton: false, showCancelButton: true, confirmButtonText: 'Approve'})
            .then(async(result) => {
              if (result.isConfirmed) {
          setOpen2(false);
          const res = await axios.post(`${url}/api/open_nl`,{
              'record_id' : record_id,
          });
  
          const resp = res.data;
          if(resp.status == true){
            setstatus('loading');
            setbool(!bool)
            setmessage2(resp.message);
            setOpen2(true);
            setAlertType('success');
          }
          else{
            setmessage2(resp.message);
            setOpen2(true);
            setAlertType('error');
          }
        }
      })
    }
      const reopen = async(record_id)=>{

        Swal.fire({ title: 'Are you sure you want to Re-Open this request?', 
            showDenyButton: false, showCancelButton: true, confirmButtonText: 'Open'})
            .then(async(result) => {
              if (result.isConfirmed) {
          setOpen2(false);
          const res = await axios.post(`${url}/api/open_nl`,{
              'record_id' : record_id,
          });
  
          const resp = res.data;
          if(resp.status == true){
            setstatus('loading');
            setbool(!bool)
            setmessage2(resp.message);
            setOpen2(true);
            setAlertType('success');
          }
          else{
            setmessage2(resp.message);
            setOpen2(true);
            setAlertType('error');
          }
        }
      })
    }

      const close = async (record_id) => {

        Swal.fire({ title: 'Are you sure you want to Re-Open this request?', 
            showDenyButton: false, showCancelButton: true, confirmButtonText: 'Close'})
            .then(async(result) => {
              if (result.isConfirmed) {
            setOpen2(false);

            const res = await axios.post(`${url}/api/close_nl`, {
            'record_id': record_id
            });

            const resp = res.data;

            if (resp.status == true) {
            setstatus('loading');
            setbool(!bool)
            setmessage2(resp.message);
            setOpen2(true);
            setAlertType('success');
            } else {
            setmessage2(resp.message);
            setOpen2(true);
            setAlertType('error');
            }   
        }})
        
      }
  
  
    return (
      <div style={data.length == 0 ? {height: '90vh'} : Number(id) == 19 ? {height: '90vh'} : null}>
          <div className='fs-3 fw-bold text-center mt-2 mb-3' style={{color: "#000078"}}>
              Edit Module (Notification Letter)
          </div>
          {status == 'loaded' ?
           data.length > 0 ?
              <>
                  <div className='col-9 mx-auto'>
                      <input className='form-control' placeholder='Search Opinion' onChange={(e)=>{setSearchTerm(e.target.value)}} />
                  </div>
                  <div className='col-10 mx-auto'>
                      <Box sx={{ width: '100%' }}>
                        <Collapse in={open2}>
                                                                    <Alert
                                                                    severity={alertType}
                                                                    action={
                                                                        <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen2(false);
                                                                        }}
                                                                        >
                                                                        <CloseIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    }
                                                                    sx={{ mb: 2 }}
                                                                    >
                                                                    {message2}
                                                                    </Alert>
                        </Collapse>
                    </Box>
                  </div>
                  <div className='mt-3 card shadow col-11 mx-auto'>
                      <table className='table table-bordered border-dark table-striped table-hover'>
                          <thead>
                              <tr>
                                  <th>#</th>
                                  <th>Opinion Name</th>
                                  <th>Team Lead</th>
                                  <th>Analyst</th>
                                  <th>Notification Date</th>
                                  <th>Status</th>
                                  <th>Action</th>
                              </tr>
                          </thead>
                          <tbody>
                              {
                                  filteredOpinions.map((value, index)=>{
                                    if(value.edit_module !== null){
                                    if(value.new_edit_module !== null){
                                            return(
                                                <>
                                                    <tr>
                                                        <td>{a++}</td>
                                                        <td>{value.Entity}</td>
                                                        <td>{value.managerName}</td>
                                                        <td>{value.pacraAnalyst}</td>
                                                        <td>{value["Notification "] !== null ? DateFormat(value["Notification "]) : ''}</td>
                                                        <td>Post FC</td>
                                                        <td>{value["Notification "] !== null ? 
                                                        // <button  data-bs-toggle="modal" data-bs-target={`#reason${value.record_id}`} className='btn btn-primary'>Open</button> 
                                                        <button className='btn btn-primary btn-sm' onClick={()=>{reopen(value.record_id)}}>Open</button> 
                                                        : 
                                                        <button className='btn btn-secondary btn-sm' onClick={()=>{close(value.record_id)}}>Close</button>}</td>
                                                    </tr>
                                                    {/* <div className="modal fade" id={`reason${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                        <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{approve(event, value.record_id, document.getElementById(`reasonid${value.record_id}`).value, document.getElementById(`submit${value.record_id}`), document.getElementById(`load${value.record_id}`), document.getElementById(`btn${value.record_id}`))}}>
                                                            <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <Box sx={{ width: '100%' }}>
                                                                <Collapse in={open}>
                                                                    <Alert
                                                                    action={
                                                                        <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen(false);
                                                                        }}
                                                                        >
                                                                        <CloseIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    }
                                                                    sx={{ mb: 2 }}
                                                                    >
                                                                    {message}
                                                                    </Alert>
                                                                </Collapse>
                                                            </Box>
                                                            <div className="modal-body">
                                                                <div className='fw-bold mt-2'>
                                                                Reason:
                                                                </div>
                                                                <div>
                                                                <textarea className='form-control'  style={{height: "100%"}} id={`reasonid${value.record_id}`} required></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" id={`reasondeclineclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                <button className="btn btn-primary" type='submit' id={`btn${value.record_id}`}><div id={`submit${value.record_id}`}>Submit</div><div id={`load${value.record_id}`} hidden={true}><i class='fa-solid fa-spinner fa-spin fa-lg'></i></div></button>
                                                            </div>
                                                            </div>
                                                        </form>
                                                    </div> */}
                                                </>
                                                )
                                    }
                                    else if(value.edit_module.original_fc_date == null){
                                        return(
                                          <>
                                              <tr>
                                                  <td>{a++}</td>
                                                  <td>{value.Entity}</td>
                                                  <td>{value.managerName}</td>
                                                  <td>{value.pacraAnalyst}</td>
                                                  <td>{value["Notification "] !== null ? DateFormat(value["Notification "]) : ''}</td>
                                                  <td>Pre FC</td>
                                                  <td>
                                                    {
                                                    Number(id) == 19 ? (
                                                        value.nl_status == 'Entered' ? 
                                                        <><button className='btn btn-info btn-sm' data-bs-toggle="modal" data-bs-target={`#reasonopen${value.record_id}`}>Reason</button> 
                                                        <button className='btn btn-success btn-sm ms-1' onClick={()=>{approve(value.record_id)}}>Approve</button> 
                                                        <button className='ms-1 btn btn-danger btn-sm' onClick={()=>{decline(value.record_id)}}>Decline</button>
                                                        </> :
                                                        value.nl_status == 'Open' ? <div className='fw-bold' style={{color:'blue'}}>Opened</div> :
                                                        value.nl_status == 'Declined' ? <div className='fw-bold' style={{color:'red'}}>Declined</div> :
                                                        value.nl_status == 'Closed' && <div className='fw-bold'>Closed</div>
                                                    ) :
                                                    (
                                                        (value.nl_status == null || value.nl_status == 'Closed' ) ?
                                                            <button  data-bs-toggle="modal" data-bs-target={`#reason${value.record_id}`} className='btn btn-primary btn-sm'>Open</button> :
                                                         value.nl_status == 'Declined' ? 
                                                        <div>
                                                            <div className='fw-bold' style={{color:'red'}}>Declined</div>
                                                            <button  data-bs-toggle="modal" data-bs-target={`#reason${value.record_id}`} className='btn btn-info btn-sm'>Request Again</button>
                                                        </div> :
                                                        value.nl_status == 'Open' ?
                                                        <button className='btn btn-secondary btn-sm' onClick={()=>{close(value.record_id)}}>Close</button> :
                                                        value.nl_status == 'Entered' ? <div className='fw-bold' style={{color:'blue'}}>Requested</div>
                                                        : null
                                                    )
                                                    }
                                                   </td>
                                                  </tr>
                                                    <div className="modal fade" id={`comment${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                        <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{recommend(event, value.record_id,document.getElementById(`commentid${value.record_id}`).value, document.getElementById(`rmsubmit${value.record_id}`), document.getElementById(`rmload${value.record_id}`), document.getElementById(`rmbtn${value.record_id}`))}}>
                                                            <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <Box sx={{ width: '100%' }}>
                                                                <Collapse in={open}>
                                                                    <Alert
                                                                    action={
                                                                        <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen(false);
                                                                        }}
                                                                        >
                                                                        <CloseIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    }
                                                                    sx={{ mb: 2 }}
                                                                    >
                                                                    {message}
                                                                    </Alert>
                                                                </Collapse>
                                                            </Box>
                                                            <div className="modal-body">
                                                                <div className='fw-bold mt-2'>
                                                                Comment (if any):
                                                                </div>
                                                                <div>
                                                                <textarea className='form-control'  style={{height: "100%"}} id={`commentid${value.record_id}`} required></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" id={`commentdeclineclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                <button className="btn btn-primary" type='submit' id={`rmbtn${value.record_id}`}><div id={`rmsubmit${value.record_id}`}>Submit</div><div id={`rmload${value.record_id}`} hidden={true}><i class='fa-solid fa-spinner fa-spin fa-lg'></i></div></button>
                                                            </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <div className="modal fade" id={`reason${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                        <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{request(event, value.record_id,document.getElementById(`reasonid${value.record_id}`).value, document.getElementById(`submit${value.record_id}`), document.getElementById(`load${value.record_id}`), document.getElementById(`btn${value.record_id}`))}}>
                                                            <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <Box sx={{ width: '100%' }}>
                                                                <Collapse in={open}>
                                                                    <Alert
                                                                    action={
                                                                        <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen(false);
                                                                        }}
                                                                        >
                                                                        <CloseIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    }
                                                                    sx={{ mb: 2 }}
                                                                    >
                                                                    {message}
                                                                    </Alert>
                                                                </Collapse>
                                                            </Box>
                                                            <div className="modal-body">
                                                                <div className='fw-bold mt-2'>
                                                                Reason:
                                                                </div>
                                                                <div>
                                                                <textarea className='form-control'  style={{height: "100%"}} id={`reasonid${value.record_id}`} required></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" id={`reasondeclineclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                <button className="btn btn-primary" type='submit' id={`btn${value.record_id}`}><div id={`submit${value.record_id}`}>Submit</div><div id={`load${value.record_id}`} hidden={true}><i class='fa-solid fa-spinner fa-spin fa-lg'></i></div></button>
                                                            </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <div className="modal fade" id={`reasonopen${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                        <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{request(event, value.record_id,document.getElementById(`reasonid${value.record_id}`).value, document.getElementById(`submit${value.record_id}`), document.getElementById(`load${value.record_id}`), document.getElementById(`btn${value.record_id}`))}}>
                                                            <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                           
                                                            <div className="modal-body">
                                                                <div className='fw-bold mt-2'>
                                                                Reason:
                                                                </div>
                                                                <div>
                                                                    {
                                                                        value.nl_reason
                                                                    }
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                          </>

                                      )
                                    }
                                    else if(value.new_edit_module == null && value.edit_module.original_fc_date !== null){
                                          return(
                                                <>
                                                    <tr>
                                                        <td>{a++}</td>
                                                        <td>{value.Entity}</td>
                                                        <td>{value.managerName}</td>
                                                        <td>{value.pacraAnalyst}</td>
                                                        <td>{value["Notification "] !== null ? DateFormat(value["Notification "]) : ''}</td>
                                                        <td>Post FC</td>
                                                        <td>
                                                            {
                                                            Number(id) == 19 ? (
                                                                value.nl_status == 'Recommended' ? 
                                                                <><button className='btn btn-success btn-sm' onClick={()=>{approve(value.record_id)}}>Approve</button> 
                                                                <button className='ms-1 btn btn-danger btn-sm' onClick={()=>{decline(value.record_id)}}>Decline</button>
                                                                </> :
                                                                value.nl_status == 'Open' ? <div className='fw-bold' style={{color:'blue'}}>Opened</div> :
                                                                value.nl_status == 'Declined' ? <div className='fw-bold' style={{color:'red'}}>Declined</div> :
                                                                value.nl_status == 'Closed' && <div className='fw-bold'>Closed</div>
                                                            ) :
                                                            (
                                                                (value.nl_status == null || value.nl_status == 'Closed' ) ?
                                                                    <button  data-bs-toggle="modal" data-bs-target={`#reason${value.record_id}`} className='btn btn-primary btn-sm'>Open</button> :
                                                                value.nl_status == 'Declined' ? 
                                                                <div>
                                                                    <div className='fw-bold' style={{color:'red'}}>Declined</div>
                                                                    <button  data-bs-toggle="modal" data-bs-target={`#reason${value.record_id}`} className='btn btn-info btn-sm'>Request Again</button>
                                                                </div> :
                                                                value.nl_status == 'Recommended' ? <div className='fw-bold' style={{color:'blue'}}>Recommended</div> :
                                                                value.nl_status == 'Open' ?
                                                                <button className='btn btn-secondary btn-sm' onClick={()=>{close(value.record_id)}}>Close</button> :
                                                                value.nl_status == 'Entered' ? <div className='fw-bold' style={{color:'blue'}}>Requested</div>
                                                                : null
                                                            )
                                                            }
                                                        </td>
                                                        </tr>
                                                            <div className="modal fade" id={`comment${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                                <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{recommend(event, value.record_id,document.getElementById(`commentid${value.record_id}`).value, document.getElementById(`rmsubmit${value.record_id}`), document.getElementById(`rmload${value.record_id}`), document.getElementById(`rmbtn${value.record_id}`))}}>
                                                                    <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                                    </div>
                                                                    <Box sx={{ width: '100%' }}>
                                                                        <Collapse in={open}>
                                                                            <Alert
                                                                            action={
                                                                                <IconButton
                                                                                aria-label="close"
                                                                                color="inherit"
                                                                                size="small"
                                                                                onClick={() => {
                                                                                    setOpen(false);
                                                                                }}
                                                                                >
                                                                                <CloseIcon fontSize="inherit" />
                                                                                </IconButton>
                                                                            }
                                                                            sx={{ mb: 2 }}
                                                                            >
                                                                            {message}
                                                                            </Alert>
                                                                        </Collapse>
                                                                    </Box>
                                                                    <div className="modal-body">
                                                                        <div className='fw-bold mt-2'>
                                                                        Comment (if any):
                                                                        </div>
                                                                        <div>
                                                                        <textarea className='form-control'  style={{height: "100%"}} id={`commentid${value.record_id}`} required></textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-secondary" id={`commentdeclineclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                        <button className="btn btn-primary" type='submit' id={`rmbtn${value.record_id}`}><div id={`rmsubmit${value.record_id}`}>Submit</div><div id={`rmload${value.record_id}`} hidden={true}><i class='fa-solid fa-spinner fa-spin fa-lg'></i></div></button>
                                                                    </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            <div className="modal fade" id={`reason${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                                <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{request(event, value.record_id,document.getElementById(`reasonid${value.record_id}`).value, document.getElementById(`submit${value.record_id}`), document.getElementById(`load${value.record_id}`), document.getElementById(`btn${value.record_id}`))}}>
                                                                    <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                                    </div>
                                                                    <Box sx={{ width: '100%' }}>
                                                                        <Collapse in={open}>
                                                                            <Alert
                                                                            action={
                                                                                <IconButton
                                                                                aria-label="close"
                                                                                color="inherit"
                                                                                size="small"
                                                                                onClick={() => {
                                                                                    setOpen(false);
                                                                                }}
                                                                                >
                                                                                <CloseIcon fontSize="inherit" />
                                                                                </IconButton>
                                                                            }
                                                                            sx={{ mb: 2 }}
                                                                            >
                                                                            {message}
                                                                            </Alert>
                                                                        </Collapse>
                                                                    </Box>
                                                                    <div className="modal-body">
                                                                        <div className='fw-bold mt-2'>
                                                                        Reason:
                                                                        </div>
                                                                        <div>
                                                                        <textarea className='form-control'  style={{height: "100%"}} id={`reasonid${value.record_id}`} required></textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-secondary" id={`reasondeclineclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                        <button className="btn btn-primary" type='submit' id={`btn${value.record_id}`}><div id={`submit${value.record_id}`}>Submit</div><div id={`load${value.record_id}`} hidden={true}><i class='fa-solid fa-spinner fa-spin fa-lg'></i></div></button>
                                                                    </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                </>
                                      )
                                    }
                                  }
                                  else {
                                      if(value["Notification "] !== null){
                                            return(
                                              <>
                                                  <tr>
                                                      <td>{a++}</td>
                                                      <td>{value.Entity}</td>
                                                      <td>{value.managerName}</td>
                                                      <td>{value.pacraAnalyst}</td>
                                                      <td>{value["Notification "] !== null ? DateFormat(value["Notification "]) : ''}</td>
                                                      <td>Pre FC</td>
                                                      <td>
                                                    {
                                                    Number(id) == 19 ? (
                                                        value.nl_status == 'Recommended' ? 
                                                        <><button className='btn btn-success btn-sm' onClick={()=>{approve(value.record_id)}}>Approve</button> 
                                                        <button className='ms-1 btn btn-danger btn-sm' onClick={()=>{decline(value.record_id)}}>Decline</button>
                                                        </> :
                                                        value.nl_status == 'Open' ? <div className='fw-bold' style={{color:'blue'}}>Opened</div> :
                                                        value.nl_status == 'Declined' ? <div className='fw-bold' style={{color:'red'}}>Declined</div> :
                                                        value.nl_status == 'Closed' && <div className='fw-bold'>Closed</div>
                                                    ) :
                                                    (
                                                        (value.nl_status == null || value.nl_status == 'Closed' ) ?
                                                            <button  data-bs-toggle="modal" data-bs-target={`#reason${value.record_id}`} className='btn btn-primary btn-sm'>Open</button> :
                                                         value.nl_status == 'Declined' ? 
                                                        <div>
                                                            <div className='fw-bold' style={{color:'red'}}>Declined</div>
                                                            <button  data-bs-toggle="modal" data-bs-target={`#reason${value.record_id}`} className='btn btn-info btn-sm'>Request Again</button>
                                                        </div> :
                                                        value.nl_status == 'Open' ?
                                                        <button className='btn btn-secondary btn-sm' onClick={()=>{close(value.record_id)}}>Close</button> :
                                                        value.nl_status == 'Entered' ? <div className='fw-bold' style={{color:'blue'}}>Requested</div>
                                                        : null
                                                    )
                                                    }
                                                   </td>
                                                  </tr>
                                                    <div className="modal fade" id={`comment${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                        <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{recommend(event, value.record_id,document.getElementById(`commentid${value.record_id}`).value, document.getElementById(`rmsubmit${value.record_id}`), document.getElementById(`rmload${value.record_id}`), document.getElementById(`rmbtn${value.record_id}`))}}>
                                                            <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <Box sx={{ width: '100%' }}>
                                                                <Collapse in={open}>
                                                                    <Alert
                                                                    action={
                                                                        <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen(false);
                                                                        }}
                                                                        >
                                                                        <CloseIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    }
                                                                    sx={{ mb: 2 }}
                                                                    >
                                                                    {message}
                                                                    </Alert>
                                                                </Collapse>
                                                            </Box>
                                                            <div className="modal-body">
                                                                <div className='fw-bold mt-2'>
                                                                Comment (if any):
                                                                </div>
                                                                <div>
                                                                <textarea className='form-control'  style={{height: "100%"}} id={`commentid${value.record_id}`} required></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" id={`commentdeclineclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                <button className="btn btn-primary" type='submit' id={`rmbtn${value.record_id}`}><div id={`rmsubmit${value.record_id}`}>Submit</div><div id={`rmload${value.record_id}`} hidden={true}><i class='fa-solid fa-spinner fa-spin fa-lg'></i></div></button>
                                                            </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <div className="modal fade" id={`reason${value.record_id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                        <form className="modal-dialog modal-dialog-centered" onSubmit={(event)=>{request(event, value.record_id,document.getElementById(`reasonid${value.record_id}`).value, document.getElementById(`submit${value.record_id}`), document.getElementById(`load${value.record_id}`), document.getElementById(`btn${value.record_id}`))}}>
                                                            <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="exampleModalLabel">{value.Entity}</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <Box sx={{ width: '100%' }}>
                                                                <Collapse in={open}>
                                                                    <Alert
                                                                    action={
                                                                        <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen(false);
                                                                        }}
                                                                        >
                                                                        <CloseIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    }
                                                                    sx={{ mb: 2 }}
                                                                    >
                                                                    {message}
                                                                    </Alert>
                                                                </Collapse>
                                                            </Box>
                                                            <div className="modal-body">
                                                                <div className='fw-bold mt-2'>
                                                                Reason:
                                                                </div>
                                                                <div>
                                                                <textarea className='form-control'  style={{height: "100%"}} id={`reasonid${value.record_id}`} required></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" id={`reasondeclineclose${index}`} data-bs-dismiss="modal">Close</button>
                                                                <button className="btn btn-primary" type='submit' id={`btn${value.record_id}`}><div id={`submit${value.record_id}`}>Submit</div><div id={`load${value.record_id}`} hidden={true}><i class='fa-solid fa-spinner fa-spin fa-lg'></i></div></button>
                                                            </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                              </>
      
                                          )
                                      }
                                  }
                                  
                                })
                              }
                          </tbody>
                      </table>
                  </div>
              </> :
              <div className='fs-3 fw-bold text-center mt-5 mb-3' style={{color: "#000078"}}>
                  No rows to show!
              </div>
              :
              (<div className="mt-5 mx-auto" style={{ width: "fit-content" }}>
              <div class="wrapper" id="loader2">
                <svg
                  class="hourglass"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 120 206"
                  preserveAspectRatio="none"
                >
                  <path
                    class="middle"
                    d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
                  />
                  <path
                    class="outer"
                    d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
                  />
                </svg>
              </div>
            </div>)
          }
      </div>
    )
  
}
